"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Guardian__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_singleton",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        stateMutability: "payable",
        type: "fallback",
    },
];
class Guardian__factory {
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.Guardian__factory = Guardian__factory;
Guardian__factory.abi = _abi;
//# sourceMappingURL=Guardian__factory.js.map